/***********************************************
* Login.js
* 
* Handles the login of the application
***********************************************/
/* Layout files */
import '../assets/style/Login.css';

/* Global imports */
import React   from 'react';
import Popup   from 'reactjs-popup';
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { withTranslation }                     from 'react-i18next';

/* Local imports */
import Cookie  from './Cookie';

import { getHomeUrl } from '../App';

function renderChildren(props) {
    return React.Children.map(props.children, (child) => {
        return React.cloneElement(child, { language: props.language });
    });
};


function Header(props) {
    let navigate = useNavigate();
    let location = useLocation();

    return (
        <Cookie>
        <div className="fullPage">
            <div className='header'>
                {/* If not on the home page, show a button to go back to the home page */}
                {((location.pathname !== "/projects") && !((window.location.host.split(".")[0] === "app") && (location.pathname === "/"))) ?
                    <div className="homeDiv">
                        <div onClick={() => navigate(getHomeUrl())} className="button bigButton darkButton">{props.t("gohome")}</div>
                    </div>
                    : <></>
                }
                <div className="logoutDiv">
                    {(props.barAdditions !== undefined) ? props.barAdditions : <></> }
                    <select name="language" id="language" className="languageSelect" value={props.language.active} onChange={(e) => props.language.set(e.target.value)}>
                        {props.language.list.map((lang) => <option key={lang} value={lang}>{lang}</option>)}
                    </select>
                </div>
            </div>
            
            {/* Show all the children of the <Header /> element */}
            {renderChildren(props)}
        </div>
        </Cookie>
    );
}

export default withTranslation("Login")(Header);